import Vue from "vue";

import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import it from "./it.js";
import en from "./en.js";
import es from "./es.js";

const i18n = new VueI18n({
  locale: "it",
  messages: {
    it: it,
    en: en,
    es: es,
  },
});

export default i18n;
